import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { stages } from '../../withdrawal-of-the-application.routes';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { WithdrawalOfTheApplicationForm } from './form/withdrawal-of-the-application.form';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { updateApplication } from '../../../../../../store/actions/application.actions';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-withdrawal-of-the-application-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent
  ],
  providers: [WithdrawalOfTheApplicationForm],
  templateUrl: './withdrawal-of-the-application-section.component.html'
})
export class WithdrawalOfTheApplicationSectionComponent implements OnDestroy {

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  public stages: string[] = stages;

  public form: WithdrawalOfTheApplicationForm = inject(WithdrawalOfTheApplicationForm);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        id: this.application()?.uuid || '',
        application: this.form.value,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
